export default [
  {
    path: "/project/:proj_id",
    component: () => import("@/layouts/ProjectLayout.vue"),
    meta: {
      authRequired: true,
    },
    children: [
      // ========== 자료실 ============
      {
        path: "filelibrary/320",
        name: "filelibrary-320",
        meta: {
          activeCode: "filelibrary-320",
          boardId: 320,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/321",
        name: "filelibrary-321",
        meta: {
          activeCode: "filelibrary-321",
          boardId: 321,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/322",
        name: "filelibrary-322",
        meta: {
          activeCode: "filelibrary-322",
          boardId: 322,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/323",
        name: "filelibrary-323",
        meta: {
          activeCode: "filelibrary-323",
          boardId: 323,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/324",
        name: "filelibrary-324",
        meta: {
          activeCode: "filelibrary-324",
          boardId: 324,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/325",
        name: "filelibrary-325",
        meta: {
          activeCode: "filelibrary-325",
          boardId: 325,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/340",
        name: "filelibrary-340",
        meta: {
          activeCode: "filelibrary-340",
          boardId: 340,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/341",
        name: "filelibrary-341",
        meta: {
          activeCode: "filelibrary-341",
          boardId: 341,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/342",
        name: "filelibrary-342",
        meta: {
          activeCode: "filelibrary-342",
          boardId: 342,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/343",
        name: "filelibrary-343",
        meta: {
          activeCode: "filelibrary-343",
          boardId: 343,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/347",
        name: "filelibrary-347",
        meta: {
          activeCode: "filelibrary-347",
          boardId: 347,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },


      {
        path: "filelibrary/454",
        name: "filelibrary-454",
        meta: {
          activeCode: "filelibrary-454",
          boardId: 454,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/455",
        name: "filelibrary-455",
        meta: {
          activeCode: "filelibrary-455",
          boardId: 455,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
    ],
  },
];
